import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IonButton, useIonViewWillEnter } from '@ionic/react';
import { PageLayout } from 'containers/layout';
import { PaySelectors } from 'redux/PayRedux';

function CardNoticePage() {
  const history = useHistory();
  const paymentMethods = useSelector(PaySelectors.selectPaymentMethods);

  useIonViewWillEnter(() => {
    if (paymentMethods.length > 0) {
      history.push('/locations', { notice: true });
    }
  });

  return (
    <PageLayout hideHeader>
      <div className="full-height">
        <div className="center-flex-content ion-padding">
          <p>
            Before you can view your restaurant check or open a bar tab you must
            add a payment method.
          </p>
          <p>
            Adding a payment method and paying your check through Vēmos Pay is
            more secure than handing a card to a server or bartender.
          </p>
        </div>
        <div className="ion-padding">
          <IonButton
            color="secondary"
            expand="block"
            fill="solid"
            type="button"
            onClick={() =>
              history.push('/payment-methods/add', { notice: true })}
          >
            Add Payment
          </IonButton>
        </div>
        <div className="ion-padding mb-5x">
          <IonButton
            color="light"
            expand="block"
            fill="solid"
            type="button"
            onClick={() => history.push('/locations')}
          >
            I'll Do This Later
          </IonButton>
        </div>
      </div>
    </PageLayout>
  );
}

export default CardNoticePage;
